export default class Routes {
    public static readonly home = "/";
}



// WEBPACK FOOTER //
// ./src/Routes.ts